import React, { useContext } from "react";
// import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { MyDNVContext } from "mydnv/context/mydnv-context";

export const WhenSignedIn = (props) => {
    const { children } = props;
    const { AuthenticatedTemplate, UnauthenticatedTemplate } = useContext(MyDNVContext);

    return (
        <>
            <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
            <UnauthenticatedTemplate></UnauthenticatedTemplate>
        </>
    );
};

export const WhenSignedOut = (props) => {
    const { children } = props;
    const { AuthenticatedTemplate, UnauthenticatedTemplate } = useContext(MyDNVContext);

    return (
        <>
            <AuthenticatedTemplate></AuthenticatedTemplate>
            <UnauthenticatedTemplate>{children}</UnauthenticatedTemplate>
        </>
    );
};
